export const tooltips = {
    'eventstatus':'Events Hosted and Results Upload ( Wed-Tues ).',
    'eventsthisweek':'Number of events this week from today through Sunday. To view the full list of upcoming events click here.',
    'lastrankingrun':'View the last Ranking run date and time. Admin can Rerun ranking and perform What if? scenarios.',
    'orphanedevents':'Number of orphaned events. To view the full list of orphaned events click here.',
    'userrequests':'View of consumer requests to access the portal along with their status.',
    'exceptions':'Displays any exceptions found after an upload or ranking is performed.'
}




// WEBPACK FOOTER //
// ./src/utils/constants/tooltip.js